import React, { useState } from 'react'
import Nike from '../../../styles/img/nike-card.png'
import QRImg from "../../../styles/img/qr-img.png"
import {
    UiButtonPrimary,
    UiButtonIcon,
    UiButtonSecondary,
} from "../../_uiComponents/form/UiButton";
import ReactCardFlip from "react-card-flip";
import CloseBlackIcon from '../../../styles/img/svg/CloseBlackIcon';

export default function UiWalletCard(props) {
    const [flip, setFlip] = useState(false);

    const onViewQrCode = () => {
        setFlip(!flip);
    }

    return (
        <>
            <div className='sb-walletcard'>
                
                    <div className='sb-walletcard__title'>
                        <h5>{props.title}</h5>
                    </div>
                
                    <div className='sb-walletcard__points'>
                        <label>{props.points} Points</label>
                    </div>
               
                    <div className='sb-walletcard__img'>
                        <img src={props.img} />
                    </div>
                    {/* <div className='sb-walletcard__qr-img'>
                        <span onClick={onViewQrCode} className='sb-qr-close-icon'><CloseBlackIcon/></span>
                        <img src={QRImg} />
                    </div> */}
                    {props.children}
               
                {/* {flip &&
                    <h4 className='sb-qr-scan-me'>SCAN ME</h4>
                }
                {!flip &&
                    <>
                        <UiButtonSecondary
                            btnName="View QR CODE"
                            onClick={onViewQrCode}
                            subName="Click to spend in store" />
                        <div className='sb-wallet-redeem-btn'>

                            <UiButtonPrimary
                                btnName="Redeem Online"
                                onClick={props.redeemOnline}
                                subName="Save code to clipboard" />
                        </div>
                    </>
                }
                <p>Manage your wallet by clicking the 'Redeemed' button after spending.
                    Your spent vouchers will then be easily identified.</p>

                <div className='sb-walletcard__bottom' >
                    {!flip &&
                        <div className='sb-wallet-view'>
                            <UiButtonPrimary btnName="View Order" onClick={props.viewOrder} />
                        </div>
                    }
                    {props.redeemed ?

                        <div className='sb-wallet-reset' style={flip ? { width:'100%'} : {}}>
                            <UiButtonPrimary btnName="Reset" onClick={props.reset} />
                        </div> :

                        <div className='sb-wallet-redeem' style={flip ? { width:'100%'} : {}}>
                            <UiButtonPrimary btnName="Redeemd" onClick={props.redeem} />
                        </div>
                    }

                </div>
                {props.redeemed &&
                    <div className='sb-walletcard__redeemed'>
                        <h4>Redeemed</h4>
                    </div>
                } */}
            </div>

        </>
    )
}
